<template>
  <NuxtLayout name="default" shoppingSrc="/online-shopping/internet-phone/">
    <LazyHydrate when-idle>
      <ProductTopCard :details="topCardData">
        <template #title>
          <h1
            class="font-extrabold just-desktop text-2xl mb-5 text-start text-blue-500"
          >
            {{ topCardData.title }}<span v-if="topCardData.subtitle">؛</span>
            {{ topCardData.subtitle }}
          </h1>
          <div
            class="font-extrabold just-mobile mb-5 text-center text-blue-500"
          >
            <div class="text-xl mb-1">{{ topCardData.title }}</div>
            <div class="text-base">{{ topCardData.subtitle }}</div>
          </div>
        </template>
      </ProductTopCard>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <BaseSecondCard :details="secondCardData" />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <section class="gridClass mt-16">
        <div class="text-center font-bold">
          <div class="mb-4 laptop:mb-10">
            <h2 class="text-base laptop:text-2xl">
              ویژگی‌های اصلی تلفن ثابت اینترنتی نواتل
            </h2>
          </div>
          <section class="grid grid-cols-2 laptop:grid-cols-3 gap-x-4 gap-y-10">
            <ProductAdvantage
              v-for="item in advantages"
              :key="item.id"
              :item="item"
            />
          </section>
        </div>
      </section>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div class="gridClass mt-16">
        <ProductSecondCard :data="grayCardData" showTik />
      </div>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <section class="gridClass mt-20">
        <div class="mb-4 laptop:mb-10">
          <h3 class="text-center font-bold text-base laptop:text-2xl">
            امکانات تلفن اینترنتی نواتل
          </h3>
        </div>
        <div class="just-desktop">
          <div class="grid grid-cols-1 laptop:grid-cols-2 gap-4">
            <ProductPossibility
              v-for="item in possibilities"
              :key="item.id"
              :item="item"
            />
          </div>
        </div>
        <div class="just-mobile">
          <div class="grid grid-cols-1 laptop:grid-cols-2 gap-4">
            <ProductPossibility :item="allPossibilities" />
          </div>
        </div>
      </section>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <PricesInternetPhone id="internetPhone_price" class="mb-5 mt-10" title="پلن‌ قیمت‌گذاری" />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <SectionTable class="mt-16" />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <h3 class="text-center text-2xl font-bold pb-6 mt-16">
        نواتل در یک نگاه
      </h3>
      <SectionPossibilities />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <ProductMoreInformation
        :details="moreInfoData"
        class="mt-10 laptop:mt-32"
      />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <SectionQuestions :data="questionData" />
    </LazyHydrate>
  </NuxtLayout>
</template>

<script setup>
definePageMeta({
  layout: false,
});

useSeoMeta({
  title: "خرید خط تلفن ثابت اینترنتی (خرید تلفن VoIP)",
  description:
    "تجربه جدید تماس‌های اینترنتی با کیفیت و پایداری بالا! تماس‌های بدون قطعی، مدیریت آسان و صرفه‌جویی در هزینه‌ ها با تلفن اینترنتی نواتل",
});

useHead({
  link: [
    {
      rel: "canonical",
      href: "https://navatel.ir/products/internet-phone/",
    },
  ],
});

const topCardData = {
  id: "1",
  title: "خط تلفن اینترنتی",
  subtitle: "انقلابی در صنعت ارتباطات",
  desc: `با خرید تلفن اینترنتی، تنها در طی چند دقیقه خط ثابت از پیش‌شماره هر استانی که نیاز دارید دریافت کنید. این خطوط اینترنتی، نسل جدید خطوط مخابراتی هستند که به‌جای استفاده از کابل‌های قدیمی، بر بستر اینترنت ارائه می‌شوند. به همین دلیل، کیفیت تماس‌های ورودی و خروجی شما به مراتب بالاتر از خطوط سنتی رفته و همچنین تمام هزینه‌های مربوط به خرید سخت‌افزار حذف خواهد شد.`,
  img: "/img/product/internetPhone.webp",
  // imgClass: "laptop:!w-[80%] laptop:float-left",
  firstButton: {
    text: "دمو و مشاوره رایگان",
    modalId: "main",
    styleType: "primary",
  },
  secondButton: {
    text: "مشاهده قیمت‌ها",
    scrollTo: "internetPhone_price",
    styleType: "secondary",
  },
};

const secondCardData = {
  videoImg: { img: "/img/static.webp", video: "/video/static.mp4" },
  alt: "کاور تلفن اینترنتی نواتل",
};

const advantages = [
  {
    id: 0,
    title: "اپلیکیشن اختصاصی",
    text: "برقراری تماس با خط تلفن اینترنتی، از طریق اپلیکیشن اختصاصی برقرار می‌شود که در نقش یک پیام‌رسان و سافت‌فون فرایندهای ارتباطی سازمان را تسهیل می‌کند.",
    icon: "16",
  },
  {
    id: 1,
    title: "25 سال پشتیبانی قدرتمند",
    text: "تیم پشتیبانی فنی نواتل ۲۴ ساعته و در ۷ روز هفته در طول 25 سال، پایداری سرویس‌های شما را تضمین نموده و آماده پاسخگویی به مشتریان و همراهان گرامی می‌باشد.",
    icon: "support",
  },
  {
    id: 2,
    title: "پیش‌شماره برای ۳۱ استان کشور",
    text: "استفاده از خطوط تلفن اینترنتی، هیچ محدودیت جغرافیایی‌ای ندارد! در هر استانی که سکونت دارید، می‌توانید صاحب یک خط تلفن اینترنتی با پیش شماره دلخواه شوید.",
    icon: "phone",
  },
  {
    id: 3,
    title: "امکان دایورت تماس",
    text: "اگر نیاز به دایورت خط ثابت کسب‌وکار خود بر روی خط نواتلی دارید و یا می‌خواهید یک شماره دایورتی برای شرایط خاص داشته باشید، در نواتل این امکان فراهم است تا هیچ تماسی را از دست ندهید.",
    icon: "divert",
  },
  {
    id: 4,
    title: "بدون نیاز به کابل و سیم‌کشی",
    text: "به راحتی و بدون انتظار برای اعلام مخابرات و کابل‌کشی از خط تلفن اینترنتی استفاده کنید؛ چرا که هیچ پیش نیاز سخت‌افزاری‌ای ندارد و راه‌اندازی آن در بستر ابری صورت می‌گیرد.",
    icon: "17",
  },
  {
    id: 5,
    title: "اتصال به پنل مدیریتی",
    text: "شما می‌توانید با خرید خط تلفن اینترنتی و اتصال به مرکز تماس ابری، به تعداد دلخواه همزمانی تماس داشته و از مزایای پنل مدیریتی استفاده کنید.",
    icon: "19",
  },
];

const grayCardData = {
  title: "مزایای خط ثابت اینترنتی نسبت به خط ثابت مخابرات",
  img: "/img/product/internetPhone2.webp",
  options: [
    {
      id: 1,
      text: "خط ثابت در جیب شما؛ حتی در هنگام سفر! تنها با داشتن اینترنت و گوشی هوشمند در هر نقطه از جهان می‌توانید تماس‌های ورودی را دریافت و تماس‌های خروجی را برقرار کنید!",
    },
    {
      id: 4,
      text: "برقراری تماس‌ها با هر اینترنتی. فرقی نمی‌کند که اینترنت‌تان را از کدام شرکت خریداری کرده‌اید؛ خط تلفن اینترنتی نواتل با هر شرکت و سرعت اینترنتی بدون مشکل کار می‌کند و تماس‌های فوق‌العاده باکیفیتی را برایتان رقم خواهد زد.",
    },
    {
      id: 3,
      text: "در صورت خرید تلفن اینترنتی، چالش‌های انتقال یا تغییر خط تلفن را نخواهید داشت. و می‌توانید بارها محل کسب‌وکار خود را عوض کنید بی آن که شماره معتبر خود را از دست بدهید.",
    },
  ],
};

const possibilities = [
  {
    id: "1",
    list: [
      {
        text: "اپلیکیشن اختصاصی ویندوز و اندروید و نسخه تحت وب نواتل",
        icon: "smartphone",
      },
      {
        text: "بدون هزینه انتقال، مکالمات ارزان و دریافت نوتیف تماس",
        icon: "dolar-bg",
      },
      {
        text: "بدون قطعی خط تلفن حتی در زمان استفاده از  فیلتر شکن",
        icon: "79",
      },
      {
        text: "هلد و ترنسفر تماس‌ها و قابلیت ویدئو کنفرانس و تماس گروهی",
        icon: "call-profile",
      },
    ],
  },
  {
    id: "2",
    list: [
      {
        text: "پیش شماره برای ۳۱ استان و انتخاب خط مطابق با نیازمندی شما",
        icon: "phone",
      },
      {
        text: "دایورت خطوط پیشین شرکت به خط ثابت اینترنتی و سیستم جدید",
        icon: "divert",
      },
      {
        text: "یک خط واقعی و ثابت برای دریافت اینماد یا افتتاح حساب بانکی",
        icon: "document",
      },
      {
        text: "بدون نیاز به کابل، سیم‌کشی و هیچ‌گونه سخت‌افزار و تجهیزات ",
        icon: "17",
      },
    ],
  },
];

const allPossibilities = computed(() => {
  const items = [];
  possibilities.forEach((element) => {
    items.push(...element.list);
  });
  return {
    id: "0",
    list: items,
  };
});

const moreInfoData = {
  id: "1",
  title: "درباره نواتل بیشتر بدانید",
  items: [
    {
      id: "1",
      text: "مقایسه تلفن ابری با تلفن ثابت مخابرات | دو نسل تلفن",
      img: "/img/articles/internetPhone1.webp",
      url: `https://navatel.ir/blog/%d9%85%d9%82%d8%a7%db%8c%d8%b3%d9%87-%d8%af%d9%88-%d9%86%d8%b3%d9%84-%d8%aa%d9%84%d9%81%d9%86-%d8%a7%d8%a8%d8%b1%db%8c-%db%8c%d8%a7-%d8%ab%d8%a7%d8%a8%d8%aa/`,
    },
    {
      id: "2",
      text: "افزایش رضایتمندی مشتریان با ارتباط مرکز تلفن ابری با CRM",
      img: "/img/articles/cloudPbx2.webp",
      url: `https://navatel.ir/blog/%d8%a7%d8%b1%d8%aa%d8%a8%d8%a7%d8%b7-%d9%85%d8%b1%da%a9%d8%b2-%d8%aa%d9%84%d9%81%d9%86-%d8%a7%d8%a8%d8%b1%db%8c-crm/`,
    },
    {
      id: "3",
      text: "مراحل نصب و راه‌اندازی تلفن ویپ (VoIP) +هزینه",
      img: "/img/articles/cloudPbx3.webp",
      url: `https://navatel.ir/blog/voip-phone-setup-steps/`,
    },
  ],
};

const questionData = {
  title: "سؤالات متداول تلفن اینترنتی نواتل",
  items1: [
    {
      title:
        "آیا امکان اضافه کردن ویژگی‌های مرکز تلفن به تلفن اینترنتی وجود دارد؟",
      text: "بله، شما با خرید بسته مرکز تلفن ابری می‌توانید ویژگی‌های مورد نیازتان را مانند اتصال به CRM، منشی گویا، کنترل آنلاین مکالمات، دریافت گزارش‌های حرفه‌ای و… به خط تلفن ثابت اینترنتی خود اضافه کنید.",
    },
    {
      title: "در خط تلفنی اینترنتی نواتل هزینه دایورت تماس چقدر است؟",
      text: "هزینه دایورت تماس‌ها در خط تلفن اینترنتی نواتل معادل برقراری تماس‌های خروجی است.",
    },
    {
      title: "آیا امکان اتصال خط تلفن ابری به تلفن رومیزی وجود دارد؟",
      text: "تلفن‌های تحت شبکه (آی پی فون) قابلیت اتصال به تلفن ثابت اینترنتی را دارند.",
    },
  ],
  items2: [
    {
      title: "آیا امکان خرید سرشماره تهران از سایر استان‌ها وجود دارد؟",
      text: "بله، شما می‌توانید از هر استانی که هستید خط ابری با کد ۰۲۱ یا هر استان دیگری را تهیه کنید.",
    },
    {
      title: "آیا برای خرید تلفن اینترنتی باید شرکت ثبت شده داشته باشیم؟",
      text: "خیر. امکان خرید تلفن اینترنتی برای مشترکان حقیقی و حقوقی بدون هیچ مانعی وجود دارد.",
    },
    {
      title: "مالکیت خطوط ابری به چه صورت است؟",
      text: "خطوط مخابرات و خطوط ابری شامل مالکیت دائم نیستند و تا هنگامی که هزینه اشتراک سالیانه (به جای آبونمان) به‌صورت ماهانه پرداخت شود خط در مالکیت مشتری خواهد بود.",
    },
  ],
};
</script>
